<script setup lang="ts">
import { computed } from 'vue'
const props = withDefaults(
  defineProps<{ src?: string; name?: string; size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'; verified?: boolean }>(),
  { size: 'md' },
)
const initials = computed(() => {
  if (!props.name) return ''
  return props.name.trim().split(/\s+/).slice(0, 2).map(w => w[0]?.toUpperCase() ?? '').join('')
})
</script>

<template>
  <span class="k-avatar" :class="`k-avatar--${size}`">
    <img v-if="src" :src="src" :alt="name ?? ''" class="k-avatar__img" />
    <span v-else class="k-avatar__initials" :aria-label="name">{{ initials }}</span>
    <span v-if="verified" class="k-avatar__verified" aria-label="Verified">
      <svg viewBox="0 0 16 16" width="10" height="10" aria-hidden="true">
        <path d="M2 8l4 4 8-8" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </span>
  </span>
</template>

<style scoped>
.k-avatar {
  position: relative; display: inline-flex; align-items: center; justify-content: center;
  border-radius: var(--k-radius-circle); background: var(--k-color-bg-alt);
  color: var(--k-color-text-body); overflow: visible; flex: none;
  font-weight: var(--k-font-weight-medium);
}
.k-avatar__img { width: 100%; height: 100%; object-fit: cover; border-radius: var(--k-radius-circle); }
.k-avatar__initials {
  width: 100%; height: 100%; display: inline-flex; align-items: center; justify-content: center;
  border-radius: var(--k-radius-circle);
}
.k-avatar--xs { width: 24px; height: 24px; font-size: var(--k-font-size-xs); }
.k-avatar--sm { width: 32px; height: 32px; font-size: var(--k-font-size-xs); }
.k-avatar--md { width: 40px; height: 40px; font-size: var(--k-font-size-sm); }
.k-avatar--lg { width: 56px; height: 56px; font-size: var(--k-font-size-md); }
.k-avatar--xl { width: 80px; height: 80px; font-size: var(--k-font-size-xl); }

.k-avatar__verified {
  position: absolute; right: -2px; bottom: -2px;
  width: 16px; height: 16px; border-radius: var(--k-radius-circle);
  background: var(--k-color-secondary); color: var(--k-color-text-inverse);
  display: inline-flex; align-items: center; justify-content: center;
  border: 2px solid var(--k-color-bg);
}
.k-avatar--lg .k-avatar__verified, .k-avatar--xl .k-avatar__verified { width: 22px; height: 22px; }
</style>
